import { i18n_config_default } from './chunk-5FPUWZMY.mjs';
import groupBy from 'lodash/groupBy';

var printerMap = (printer) => ({
  id: printer.id,
  name: printer.name,
  status: printer.status,
  backupPrinter: printer.backupPrinterId || 0
});
var printerCenterFactory = (printers) => {
  const groupedPrinters = groupBy(printers, "type");
  return Object.entries(groupedPrinters).map(([printerType, printerGroup], index) => ({
    id: index + 1,
    name: i18n_config_default.t(`printerTypes.${printerType}`),
    data: Object.values(printerGroup).filter((printer) => printer.showInPrinterCenter).map(printerMap)
  })).filter((printerGroup) => printerGroup.data.length > 0);
};
var printerFactory = (printers, currentPrinter) => Object.values(printers).filter((printer) => printer.id !== currentPrinter).map(printerMap);
var generateNoPrinterOption = () => ({
  label: i18n_config_default.t("navBar.common.printerCenter.noPrinterOption"),
  value: 0
});
var printerDropdownOptionsFactory = (printers, currentPrinter) => [
  generateNoPrinterOption(),
  ...printerFactory(printers, currentPrinter).map((printer) => ({
    label: printer.name,
    value: printer.id
  }))
];
var printerListElementOptionsFactory = (printers, currentPrinter) => [
  generateNoPrinterOption(),
  ...printerFactory(printers, currentPrinter).map((printer) => ({
    label: printer.name,
    value: printer.id
  }))
];
var printersModalOptions = (printers, currentPrinterId) => {
  let options = Object.keys(printers).map((printerId) => ({
    label: printers[printerId].name,
    value: Number(printerId)
  }));
  options = options.filter((option) => option.value !== currentPrinterId);
  return options;
};

export { printerCenterFactory, printerDropdownOptionsFactory, printerFactory, printerListElementOptionsFactory, printersModalOptions };
